(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-shape"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-cookie-shape')) {
		class LCookieShape extends HTMLElement {
			constructor() {
				super()
				this._onClick = this._onClick.bind(this)
				this._onModalClosed = this._onModalClosed.bind(this)
			}

			connectedCallback() {
				this.addEventListener('click', this._onClick)
				document.body.addEventListener('modalClosed', this._onModalClosed)
				this._applyActiveShape()

				// Custom buttons may render after this block in the product form
				requestAnimationFrame(() => this._applyActiveShape())
				if (document.readyState === 'loading') {
					document.addEventListener('DOMContentLoaded', () => this._applyActiveShape(), { once: true })
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
				document.body.removeEventListener('modalClosed', this._onModalClosed)
			}

			_onModalClosed() {
				requestAnimationFrame(() => {
					this.scrollIntoView({ behavior: 'smooth', block: 'center' })
				})
			}

			_applyActiveShape() {
				const activeCard =
					this.querySelector('[data-shape-handle].is-active') || this.querySelector('[data-shape-handle]')
				if (activeCard) this._selectShape(activeCard)
			}

			_selectShape(card) {
				const handle = card.getAttribute('data-shape-handle')
				if (!handle) return

				this.querySelectorAll('[data-shape-handle]').forEach((el) => {
					el.classList.toggle('is-active', el === card)
				})

				const matchClass = 'l-customize-' + handle + '-cookie'
				document.querySelectorAll('.l-customize-cta').forEach((el) => {
					el.style.display = el.classList.contains(matchClass) ? 'flex' : 'none'
				})
			}

			_onClick(event) {
				const card = event.target.closest('[data-shape-handle]')
				if (!card || !this.contains(card)) return
				this._selectShape(card)
			}
		}

		customElements.define('l-cookie-shape', LCookieShape)
	}
  } catch(e) { console.error(e); }
})();

})();
